import { Drawer, GlobalToken } from 'antd';
import styled from 'styled-components';
import { breakpoints } from '@/utils/util-breakpoints';

export const StyledButtonDrawer = styled(Drawer)<{ theme: { token: GlobalToken } }>`
  &.continue-button-drawer {
    pointer-events: none;

    .ant-drawer-content-wrapper {
      background: transparent;
      transition: ${({ theme: { token } }) => `transform ${token.motionDurationMid} ${token.motionEaseInOut}`};
      pointer-events: auto;
    }

    &.continue-button-drawer-custom .ant-drawer-content {
      background: ${({ theme: { token } }) => token.colorBgElevated};
      border-top-left-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
      border-top-right-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
      box-shadow: ${({ theme: { token } }) => `0 -4px 12px ${token.colorBoxShadow}`};
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      &.continue-button-drawer-custom .ant-drawer-content,
      &.continue-button-drawer-custom .ant-drawer-wrapper-body .ant-drawer-content {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
        backdrop-filter: none;
      }
    }

    .ant-drawer-body {
      padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingLG}px;
      padding-bottom: max(
        ${({ theme: { token } }) => token.paddingLG}px,
        env(safe-area-inset-bottom, ${({ theme: { token } }) => token.paddingLG}px)
      );
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border-top: none;
      pointer-events: auto;
      background: ${({ theme: { token } }) => token.colorBgElevated};
    }

    &.ant-drawer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .ant-btn {
      width: 100%;
      height: ${({ theme: { token } }) => token.controlHeightLG}px;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
      box-shadow: ${({ theme: { token } }) => `0 2px 8px ${token.colorBoxShadow}`};
      pointer-events: auto;
    }
  }

  .button-container {
    width: 100%;
    max-width: 480px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    pointer-events: auto;
  }
`;
